import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MainLayOut from "../layout/MainLayOut";

const tabs = [ 
  {
    label: "Orders, Delivery & Payment",
    questions: [
      "How do I know if my order was successfully placed?",
      "What are the charges that will apply on my order?",
      "Why can't I see the COD option?",
      "I am unable to add products to my Bag",
      "My order is shipped but not yet delivered",
      "I have not received an order confirmation",
      "I want to change the phone number for the order",
      "I wasn't available at the time of delivery, but I want my order. What do I do?",
      "I tried to make a transaction, but it failed. What do I do?",
      "I have self-shipped. How do I get the refund?",
      "Will MPI Virgin Plastic employee ask for my confidential information?",
      "How can I get a refund of the COD charges?"
    ],
    slug: "order-delivery-payment",
  },
  {
    label: "Cancellations",
    questions: [
      "Can I cancel my order for plastic planters?",
      "How do I cancel my order which is already in progress?",
      "Can I cancel my cancellation request?"
    ],
    slug: "cancellations",
  },
  {
    label: "Refunds & Returns",
    questions: [
      "How do I return my plastic containers or planters?",
      "How will I get my refund for returned products?",
      "I wish to exchange my plastic products",
      "Self-ship Policy for returns",
      "My product has not yet been picked up.",
      "My product has been picked up, but I have not been refunded yet."
    ],
    slug: "refunds-returns",
  },
  {
    label: "My Order",
    questions: [
      "My order is not yet packed/shipped",
      "How do I check the status of my order?",
      "How can I cancel my order?"
    ],
    slug: "order",
  },
  {
    label: "My Account",
    questions: [
      "How do I change my password?",
      "How do I update my shipping address?"
    ],
    slug: "account",
  },
  {
    label: "Offers and Combos",
    questions: [
      "How to apply offers on planters and containers?",
      "Combo terms & conditions for plastic products"
    ],
    slug: "offers-combos",
  },
  {
    label: "Membership",
    questions: [
      "What is MPI Virgin Plastic Membership?",
      "What are the benefits of MPI Virgin Plastic membership?"
    ],
    slug: "membership",
  },
];

const SearchableTabs = () => {
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState(tabs[0].slug);
  const navigate = useNavigate();

  // Search logic across all questions
  const filteredTabs = tabs.map((tab) => ({
    ...tab,
    questions: tab.questions.filter((q) =>
      q.toLowerCase().replace(/\s+/g, ' ').includes(search.toLowerCase().replace(/\s+/g, ' '))
    ),
  }));

  // If searching, gather all matched questions
  const searchResults = filteredTabs.flatMap((tab) =>
    tab.questions.map((question) => ({
      question,
      slug: tab.slug,
    }))
  );

  return (
    <MainLayOut>
      <div className="max-w-7xl p-4 space-y-4 mx-auto py-10">
        <div className="p-8 text-center md:text-left">
          <h1 className="mb-4 text-2xl font-semibold">Contact Us</h1>
          <p className="font-semibold">What’s your query about?</p>
          <div className="relative mt-5 mb-10 w-fit mx-auto md:mx-0">
            <span className="absolute left-3 top-1 z-10 text-3xl rotate-[270deg] text-gray-500">⌕‍</span>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search your Query here"
              className="w-72 border border-gray-500 rounded-full pl-10 pr-4 py-2 focus:outline-none"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-4">
          {/* Tabs (Left Sidebar) */}
          <div className="w-full flex md:block md:w-1/4 border-r border-gray-200 pr-4 space-y-0 md:space-y-2  overflow-scroll scrollbar-none">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                onClick={() => {
                  setActiveTab(tab.slug);
                  setSearch(""); // reset search on tab change
                }}
                className={`block md:w-full w-fit text-nowrap text-xs md:text-base text-left px-4 py-2 rounded-lg items-center ${
                  activeTab === tab.slug
                    ? "font-bold text-black"
                    : "text-gray-500 hover:text-gray-800 mt-0"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Questions (Right Column) */}
          <div className="w-full md:w-3/4 space-y-4">
            {/* Show search results if searching */}
            {search ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {searchResults.map(({ question, slug }, idx) => {
                  const pageId = `/contact-us/${slug}/${question
                    .toLowerCase()
                    .replace(/'/g, "") // remove apostrophes
                    .replace(/[.,?/]/g, "") // remove dots, commas, question marks
                    .replace(/\s+/g, "-") // replace spaces with hyphens
                    .replace(/-+/g, "-")  // collapse multiple hyphens
                    .replace(/^-|-$/g, "") // trim hyphens from start/end
                  }`;
                  return (
                    <div
                      key={idx}
                      onClick={() =>
                        navigate(
                          `/contact-us/page?pageId=${encodeURIComponent(pageId)}`
                        )
                      }
                      className="cursor-pointer border border-gray-300 rounded-lg p-4 hover:shadow-md"
                    >
                      {question}
                    </div>
                  );
                })}
              </div>
            ) : (
              // Show questions of active tab if not searching
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {tabs
                  .find((tab) => tab.slug === activeTab)
                  ?.questions.map((question, idx) => {
                    const pageId = `/contact-us/${activeTab}/${question
                      .toLowerCase()
                      .replace(/'/g, "")
                      .replace(/[/]/g, " ")
                      .replace(/[.,?]/g, "")
                      .replace(/\s+/g, "-") // replace spaces with hyphens
                      .replace(/-+/g, "-")  // collapse multiple hyphens
                      .replace(/^-|-$/g, "") // trim hyphens from start/end
                    }`;
                    return (
                      <div
                        key={idx}
                        onClick={() =>
                          navigate(
                            `/contact-us/page?pageId=${encodeURIComponent(pageId)}`
                          )
                        }
                        className="cursor-pointer border border-gray-300 rounded-lg p-4 hover:shadow-md"
                      >
                        {question}
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        </div>
        <div className="cp_address pt-20">
          <h3 className="my-5 font-semibold">Corporate Address:</h3>
          <p>MPI Virgin Plastic</p>
          <p>Registered address: Siliguri, West Bengal, India</p>
          <p className="mt-5">
            You can reach us at support@mpivirginplastic.com with all queries. Customer Care Number -{" "}
            <Link className="font-medium text-blue-600" to={"https://wa.me/9733228888"} target="_blank" rel="noopener noreferrer">
              9733228888
            </Link>{" "}
            {/* (Mon - Sat, 10:00 AM - 7:00 PM). */}
          </p>
        </div>
      </div>
    </MainLayOut>
  );
};

export default SearchableTabs;
